import {
  GET_EDIT_ORDEN_START,
  GET_EDIT_ORDEN_SUCCESS,
  GET_EDIT_ORDEN_ERROR
} from '../actions'

const initialState = {
  loading: false,
  payload: null,
  error: null
}

const orden = (state = initialState, { type, payload, error } ) => {

  switch(type) {

    case GET_EDIT_ORDEN_START:
      return {
        ...state,
        loading: true,
        error: null
      }

    case GET_EDIT_ORDEN_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case GET_EDIT_ORDEN_ERROR:
      return {
        ...state,
        loading: false,
        error
      }
    
    default: return state

  }

}

export default orden